<template>

  <div class="col-12 mb-1 m-0 p-0">
     <b-row class="mb-5"
      > <b-col
        lg="6"
        md="6"
        sm="12"
        > <b-form-group
          > <label>Loại chuyển kho:</label> <b-form-select
            class="mt-2 select-style"
            size="sm"
            v-model="stockSlip.type"
            :options="stockSlipOptions"
            :disabled="stockSlip.id"
          ></b-form-select
          > </b-form-group
        > </b-col
      > </b-row
    > <b-row
      > <b-col
        lg="6"
        md="6"
        sm="12"
        > <b-form-group class="required-control"
          > <label class="font-weight-bold">Kho chuyển:</label> <Autosuggest
            class="border-radius-none mt-2"
            :model="stockSlip.sourceWarehouseName"
            :suggestions="stores"
            placeholder="Kho"
            :limit="200"
            @select="onSelectedSourceWarehouse"
            @change="onInputChangeSourceWarehouse"
            suggestionName="name"
            :disabled="stockSlip.id"
          /> </b-form-group
        > </b-col
      > <b-col
        > <b-form-group class="required-control"
          > <label class="font-weight-bold">Kho nhận:</label> <Autosuggest
            class="border-radius-none mt-2"
            :model="stockSlip.destinationWarehouseName"
            :suggestions="destinationStores"
            placeholder="Kho"
            :limit="200"
            @select="onSelectedDestinationWarehouse"
            @change="onInputChangeDestinationWarehouse"
            suggestionName="name"
            :disabled="stockSlip.id"
          /> </b-form-group
        > </b-col
      > </b-row
    > <b-row
      > <b-col
        lg="12"
        md="12"
        sm="12"
        > <b-form-group
          > <label>Ghi chú:</label> <b-form-textarea
            size="sm"
            v-model="stockSlip.notes"
            :placeholder="'Thêm nội dung ghi chú...'"
            :rows="6"
            :max-rows="6"
            :disabled="!editable"
          ></b-form-textarea
          > </b-form-group
        > </b-col
      > </b-row
    >
  </div>

</template>

<script>
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'

  export default {
    props: ['stockSlip', 'stores', 'editable', 'destinationStores'],
    created() {},
    data() {
      return {
        stockSlipOptions: [
          { value: 3, text: 'Chuyển tồn có thể bán' },
          { value: 5, text: 'Yêu cầu chuyển kho' },
          {
            value: 53,
            text: 'Chuyển tồn lỗi',
          },
        ],
      }
    },
    components: { Autosuggest },
    methods: {
      onSelectedSourceWarehouse(data) {
        this.$emit('onSelectedSourceWarehouse', data)
      },
      onInputChangeSourceWarehouse(data) {
        this.$emit('onInputChangeSourceWarehouse', data)
      },
      onSelectedDestinationWarehouse(data) {
        this.$emit('onSelectedDestinationWarehouse', data)
      },
      onInputChangeDestinationWarehouse(data) {
        this.$emit('onInputChangeDestinationWarehouse', data)
      },
    },
  }
</script>

<style lang="scss" scoped></style>

<style lang="css" scoped>
  .center-label label {
  margin-bottom: 0px;
}

.form-group label {
  font-weight: 500;
}
</style>

